import OrderApi from '../Api/OrderApi'

const SET_DATA = 'SET_DATA'
const START_LOADING = 'START_LOADING'
const STOP_LOADING = 'STOP_LOADING'

const initialState = {
  isLoading: false,
  store: {
    name: "",
    province: ""
  },
  days: []
}

export default {
  namespaced: true,
  state: initialState,

  getters: {
    getStore: state => state.store,
    getDays: state => state.days,
    isLoading: state => state.isLoading
  },

  mutations: {
    [START_LOADING] (state) {
      state.isLoading = true
    },

    [STOP_LOADING] (state) {
      state.isLoading = false
    },

    [SET_DATA] (state, response) {
      state.store = response.store
      state.days = response.days
    }
  },

  actions: {
    /**
     * Fetch orders
     */
    fetchOrders ({ commit }) {
      commit(START_LOADING)

      return OrderApi.getOrders()
        .then(response => {
          commit(SET_DATA, response.data)
        })
        .finally(() => {
          commit(STOP_LOADING)
        })
    }
  }
}
